<template>
  <div class="home">
    <h1>Idntf.com</h1>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// Home.vue?05ec1fe6